import { InfoIcon } from "../../assets/icons/stepsIcons/InfoIcon";
import { Modal } from "./Modal";

function InfoModal({ heading, body, isOpen, onToggle }) {
  return (
    <Modal isOpen={isOpen} toggle={onToggle}>
      <div className="flex justify-center">
        <InfoIcon />
      </div>
      <h2 className="font-bold text-lg text-center my-6">{heading}</h2>
      <p className="text-center text-sm pb-6 px-6 leading-relaxed">{body}</p>
    </Modal>
  );
}

export { InfoModal };
